const allaccreceivableagingsummary = { data: [], loading: true };
export const GetAllAccReceivableAgingSummary = (state = allaccreceivableagingsummary, action) => {
  switch (action.type) {
    case "get_allaccreceivableagingsummary":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
